<template>
  <div class="p-3" v-if="dataPermission?.includes('CNPS_AGENCY_DETAIL')">
    <div class="breadcrumb-area pos-relative w-100 px-0">
      <h1>Chi tiết đại lý - {{ info?.name || '' }}</h1>
      <div class="btn-group float-right">
        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="submitRequest()"
        >
          <i class="bx" :class="idAgency ? 'bx-save' : 'bx-add-to-queue'"></i>
          Cập nhật
        </button>
        <button type="button" class="btn font-medium btn-outline-secondary" @click="closeAdd()">
          <i class="bx bx-exit"></i> Quay lại
        </button>
      </div>
    </div>
    <b-row>
      <!-- Box 1: Thông tin đại lý -->
      <b-col cols="12" md="6">
        <DetailInfo
          title="Thông tin đại lý"
          :info="info"
          :isLoading="isLoading"
          :fields="filteredAgencyInfoFields"
        >
          <template #contractFiles="{ value }">
            <div v-if="value && value.length">
              <div v-for="(file, index) in value" :key="index">
                <a :href="file" target="_blank">File hợp đồng (PDF)</a>
              </div>
            </div>
            <div v-else>Không có file</div>
          </template>
          <template #createdDate="{ value }">
            {{ formatDateTime(value) }}
          </template>
          <template #lastModifiedDate="{ value }">
            {{ formatDateTime(value) }}
          </template>
        </DetailInfo>
      </b-col>

      <!-- Box 2: Thông tin thanh toán -->
      <b-col cols="12" md="6">
        <DetailInfo
          title="Thông tin thanh toán"
          :info="info"
          :isLoading="isLoading"
          :fields="filteredPaymentInfoFields"
        >
          <template #bankCode>
            {{ getNameBank }}
          </template>
          <template #receiveInvoice="{ value }">
            {{ value ? 'Có' : 'Không' }}
          </template>
        </DetailInfo>
      </b-col>

      <!-- Lịch sử cập nhật -->
      <b-col cols="12">
        <div class="form-detail">
          <h3 class="mb-3">Lịch sử cập nhật</h3>
          <!-- Thay đổi chỉ phần bảng lịch sử cập nhật -->
          <b-table
            :busy.sync="isLoading"
            sticky-header
            hover
            responsive
            :items="listHistory"
            :fields="fieldsTableHistory"
            selectable
            show-empty
            select-mode="single"
            :fixed="true"
            :bordered="true"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle" />
              </div>
            </template>
            <template #empty>
              <div class="text-center text-info my-2">Không có dữ liệu</div>
            </template>
            <template #cell(before)="{ item }">
              <div class="history-changes">
                <div v-if="getChangedFields(item.before, item.after).length > 0">
                  <div
                    v-for="field in getChangedFields(item.before, item.after).filter(
                      f => f !== 'keeperId' && f !== 'keeperEmail'
                    )"
                    :key="field"
                    class="changed-field"
                    v-show="
                      item.after[field] !== null &&
                      item.after[field] !== undefined &&
                      item.after[field] !== ''
                    "
                  >
                    <span class="font-weight-bold">{{ getFieldLabel(field) }}: </span>
                    <span class="old-value">
                      <span v-if="field === 'bankCode'">
                        {{ getBankNameById(item.before[field]) }}
                      </span>
                      <span v-else>
                        {{ formatFieldValue(field, item.before[field]) }}
                      </span>
                    </span>
                  </div>
                </div>
                <div v-else class="text-muted">Không có thay đổi</div>
              </div>
            </template>
            <template #cell(after)="{ item }">
              <div class="history-changes">
                <div v-if="getChangedFields(item.before, item.after).length > 0">
                  <div
                    v-for="field in getChangedFields(item.before, item.after).filter(
                      f => f !== 'keeperId' && f !== 'keeperEmail'
                    )"
                    :key="field"
                    class="changed-field"
                    v-show="
                      item.after[field] !== null &&
                      item.after[field] !== undefined &&
                      item.after[field] !== ''
                    "
                  >
                    <span class="font-weight-bold">{{ getFieldLabel(field) }}: </span>
                    <span class="new-value">
                      <span v-if="field === 'bankCode'">
                        {{ getBankNameById(item.after[field]) }}
                      </span>
                      <span v-else>
                        {{ formatFieldValue(field, item.after[field]) }}
                      </span>
                    </span>
                  </div>
                </div>
                <div v-else class="text-muted">Không có thay đổi</div>
              </div>
            </template>
            <template #cell(createdDate)="{ value }">
              {{ formatDateTime(value) }}
            </template>
            <template #cell(user)="{ item }">
              {{ item.createdByName }}
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>

    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true" />
  </div>
</template>
<script>
  import DetailInfo from '@/components/cskh/DetailInfo'
  import { historyUpdateAgency, DetailAgency } from '@/services/agencty'
  import { mapGetters } from 'vuex'
  import { BankService } from '@/services/bank.service'

  export default {
    components: {
      DetailInfo,
    },
    data() {
      return {
        info: {},
        isLoading: false,
        listHistory: [],
        idAgency: this.$route.params.id,
        fieldsTableHistory: [
          {
            key: 'createdDate',
            label: 'Thời gian',
            thStyle: 'min-width: 150px',
            formatter: value => this.formatDateTime(value),
          },
          {
            key: 'user',
            label: 'Người thao tác',
            thStyle: 'min-width: 150px',
          },
          {
            key: 'before',
            label: 'Thông tin cũ',
            thStyle: 'min-width: 250px',
          },
          {
            key: 'after',
            label: 'Thông tin mới',
            thStyle: 'min-width: 250px',
          },
        ],
        // Box 1: Thông tin đại lý
        agencyInfoFields: [
          { key: 'keeperName', label: 'Người phụ trách' },
          { key: 'createdDate', label: 'Ngày tạo' },
          { key: 'lastModifiedDate', label: 'Ngày cập nhật' },
          { key: 'name', label: 'Tên đại lý' },
          { key: 'code', label: 'Mã đại lý' },
          { key: 'email', label: 'Email' },
          { key: 'mobile', label: 'SĐT' },
          { key: 'address', label: 'Địa chỉ' },
          { key: 'contractFiles', label: 'File hợp đồng' },
        ],
        // Box 2: Thông tin thanh toán
        paymentInfoFields: [
          { key: 'accountNumberBank', label: 'STK ngân hàng' },
          { key: 'accountNameBank', label: 'Người thụ hưởng' },
          { key: 'bankCode', label: 'Ngân hàng' },
          { key: 'regionName', label: 'Khu vực' },
          { key: 'regionCode', label: 'Mã khu vực' },
          { key: 'receiveInvoice', label: 'Có nhận hóa đơn không' },
          { key: 'taxCode', label: 'Mã số thuế' },
          { key: 'businessName', label: 'Tên DN' },
          { key: 'businessRegistrationAddress', label: 'Địa chỉ ĐKKD' },
        ],
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: '',
        dataBanks: [],
      }
    },
    async created() {
      if (this.idAgency) {
        await this.fetchData()
      }
    },

    methods: {
      formatDateTime(dateTimeString) {
        if (!dateTimeString) return ''
        const date = new Date(dateTimeString)
        return date.toLocaleString('vi-VN')
      },
      async fetchData() {
        try {
          this.isLoading = true
          const bankRes = await BankService.listBank()
          if (bankRes.code === 1000) {
            this.dataBanks = bankRes.data || []
          }
          const res = await DetailAgency(this.idAgency)
          if (res.code === 1000) {
            this.info = res.data
          }
          const resHistory = await historyUpdateAgency(this.idAgency)
          if (resHistory.code === 1000) {
            this.listHistory = resHistory.data || {}
          }
        } catch (error) {
          console.error('Error fetching data:', error)
        } finally {
          this.isLoading = false
        }
      },
      closeAdd() {
        this.$router.push({ name: 'manageAgencyList' })
      },
      submitRequest() {
        this.$router.push({
          name: 'manageAgencyEdit',
          params: { id: this.idAgency },
        })
      },
      getChangedFields(before, after) {
        if (!before || !after) return []

        const fields = []
        for (const key in before) {
          // So sánh các trường giữa before và after
          if (JSON.stringify(before[key]) !== JSON.stringify(after[key])) {
            fields.push(key)
          }
        }
        return fields
      },

      getFieldLabel(fieldKey) {
        // Map fieldKey sang tên hiển thị
        const fieldMap = {
          name: 'Tên đại lý',
          code: 'Mã đại lý',
          keeperName: 'Người phụ trách',
          keeperId: 'ID người phụ trách',
          keeperEmail: 'Email người phụ trách',
          regionCode: 'Mã khu vực',
          regionName: 'Tên khu vực',
          email: 'Email',
          mobile: 'SĐT',
          address: 'Địa chỉ',
          accountNumberBank: 'STK ngân hàng',
          accountNameBank: 'Tên tài khoản',
          bankCode: 'Ngân hàng',
          receiveInvoice: 'Nhận hóa đơn',
          taxCode: 'Mã số thuế',
          businessName: 'Tên doanh nghiệp',
          businessRegistrationAddress: 'Địa chỉ ĐKKD',
          contractFiles: 'File hợp đồng',
          createdBy: 'Người tạo',
          createdDate: 'Ngày tạo',
          lastModifiedBy: 'Người cập nhật',
          lastModifiedDate: 'Ngày cập nhật',
        }

        return fieldMap[fieldKey] || fieldKey
      },
      formatFieldValue(fieldKey, value) {
        if (value === null || value === undefined) return 'Không có'

        // Format các giá trị đặc biệt
        switch (fieldKey) {
          case 'receiveInvoice':
            return value ? 'Có' : 'Không'
          case 'createdDate':
          case 'lastModifiedDate':
            return this.formatDateTime(value)
          case 'contractFiles':
            if (Array.isArray(value) && value.length > 0) {
              return `${value.length} file`
            }
            return 'Không có file'
          default:
            return value
        }
      },
      getBankNameById(bankCode) {
        if (!bankCode) return 'Không có'
        const bank = this.dataBanks.find(bank => bank.bankCode === bankCode)
        return bank ? bank.bankName : bankCode
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getNameBank() {
        const bankName = this.dataBanks.find(bank => bank.bankCode === this.info.bankCode)
        return bankName ? bankName.bankName : ''
      },
      // Lọc các field không có dữ liệu để ẩn
      filteredAgencyInfoFields() {
        return this.agencyInfoFields.filter(field => {
          // Luôn hiển thị ngày tạo, cập nhật
          if (['createdDate', 'lastModifiedDate'].includes(field.key)) {
            return true
          }
          // Với contractFiles, kiểm tra nếu là mảng có phần tử
          if (field.key === 'contractFiles') {
            return Array.isArray(this.info[field.key]) && this.info[field.key].length > 0
          }
          // Với các trường khác, kiểm tra nếu có dữ liệu
          return (
            this.info[field.key] !== null &&
            this.info[field.key] !== undefined &&
            this.info[field.key] !== ''
          )
        })
      },
      // Lọc các field không có dữ liệu để ẩn
      filteredPaymentInfoFields() {
        return this.paymentInfoFields.filter(field => {
          // Kiểm tra trường hợp boolean
          if (field.key === 'receiveInvoice') {
            return true // Luôn hiển thị
          }
          // Kiểm tra nếu có dữ liệu
          return (
            this.info[field.key] !== null &&
            this.info[field.key] !== undefined &&
            this.info[field.key] !== ''
          )
        })
      },
    },
  }
</script>

<style scoped>
  .form-detail {
    background-color: #fff;
    border-radius: 0.25rem;
    padding: 1rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  }
  h3 {
    font-size: 1.25rem;
    font-weight: 600;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
  }
  .history-changes {
    max-height: 300px;
    overflow-y: auto;
  }
  .changed-field {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px dashed #eee;
  }
  .changed-field:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  /* Màu cho các giá trị bị thay đổi (chỉ áp dụng cho after) */
  .old-value {
    color: #dc3545; /* Màu đỏ */
  }
  .new-value {
    color: #28a745; /* Màu xanh lá */
  }
</style>
